import React from "react";
import { arraysEqual } from 'helpers/utils'
//import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ShotTracker from 'components/sports/glf/component/ShotTracker'
import PlayByPlay from 'components/sports/glf/component/PlayByPlay'
import Statistics from 'components/sports/glf/component/Statistics'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

export const TableExpanded = React.memo((props) => {
    const { mirs_rsc } = useUrlFriendlyToParameters()
    const { row, cumulativeData, unitsData, statsData, playerStatsData, favData, setFavData } = props;
    const participant = row?.participant.code

    return (
        <Tabs id={`glf-participant-tabs-${mirs_rsc}-${participant}`}
            defaultActiveKey={`shottracker-${mirs_rsc}-${participant}`}
            className="mt-0 mb-3 mirs-tab-result"
            mountOnEnter={true}
            unmountOnExit={true}
        >
            <Tab eventKey={`shottracker-${mirs_rsc}-${participant}`} title={<Label data="HeaderShotTracker" />} disabled={false} >
                <ShotTracker 
                    participant={participant} 
                    cumulativeData={cumulativeData} 
                    unitsData={unitsData} 
                    statsData={statsData}  
                    favData={favData} 
                    setFavData={setFavData} />
            </Tab>
            <Tab eventKey={`pbp-${mirs_rsc}-${participant}`} title={<Label data="HeaderPlayByPlay" />} disabled={false}>
                <PlayByPlay participant={participant} cumulativeData={cumulativeData} unitsData={unitsData} />
            </Tab>
            <Tab eventKey={`stats-${mirs_rsc}-${participant}`} title={<Label data="HeaderStatistics" />} disabled={false}>
                <Statistics participant={participant} statsData={playerStatsData} />
            </Tab>
        </Tabs>
    )
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    return (
        //renderizamos cuando un dato de los visibles cambia
        arraysEqual(prevProps.unitsData, nextProps.unitsData)
    )
});
